function LeftBarMenuItem({
    textLabel = 'Menu Item',
    iconUrl = '/icon/without_w_b_icon.png',
    isOpened = true,
    isSpecial = false
}) {
    const icon = iconUrl ? <div className='main-menu-icon-wrapper'><img src={iconUrl} alt={`${textLabel} icon`} className='menu-item-icon' /></div> : null;
    const label = isOpened ? (
        <div className='menu-item-label'>
            {textLabel}
        </div>
    ) : null;
    return (
        <div className={`menu-item ${isSpecial ? 'menu-special' : ''}`}>
            {icon}
            {label}
        </div>
    );
}

export default LeftBarMenuItem;